var map = {
	"./company2/footer.jpg": "307e",
	"./company2/header.jpg": "f19d",
	"./company3/footer.jpg": "a2f3",
	"./company3/header.jpg": "b414",
	"./company3/watermark.jpg": "9227",
	"./company4/footer.png": "f3f9",
	"./company4/header.png": "ffc1",
	"./company4/watermark.png": "1758",
	"./company5/footer.png": "2e97",
	"./company5/header.png": "ea16",
	"./company5/watermark.png": "a85d",
	"./company9/footer.jpg": "f4b0",
	"./company9/header.jpg": "f6c1",
	"./company9/watermark.jpg": "fd01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7610";